import React from "react";
import { Button, Card, CardBody, Table, Row, Col, Input } from "reactstrap";
import { useNavigate } from "react-router-dom";
import PanelHeader from "components/panelheader/panelHeader";
import PaginationControls from "components/paginationcontrols/paginationControls";
import { usePageLoading } from "hooks/usePageLoading";
import { getUsers, deleteUser } from "services/userService";
import { getConfig } from "config/config";
import { toastBigError, toastConfirm } from "components/utils/toasts";
import { cleanString } from "components/utils/cleanString";
import { paginate } from "components/utils/paginate";
import _ from "lodash";

const Usuarios = (props) => {
  const doneLoading = usePageLoading(props);
  const [allRecords, setAllRecords] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [sortColumn, setSortColumn] = React.useState({ path: "apellido", order: "asc" });
  const [searchQuery, setSearchQuery] = React.useState("");
  const config = getConfig();
  const pageSize = config.recordsPerPage;
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const records = await getUsers();
      if (records === "NETWORK ERROR") toastBigError("Error", "Error de Conexión");
      else setAllRecords(records);
    } catch {
    } finally {
      doneLoading();
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  const getPagedData = () => {
    let filtered = [];
    if (searchQuery.trim().length > 0) {
      filtered = allRecords.filter(
        (m) =>
          cleanString((m.apellido || "") + " " + (m.nombre || "")).includes(cleanString(searchQuery)) ||
          cleanString(m.email || "").includes(cleanString(searchQuery))
      );
    } else {
      filtered = allRecords;
    }
    const ordered = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
    const records = paginate(ordered, currentPage, pageSize);
    return { totalCount: filtered.length, records };
  };

  const { totalCount, records } = getPagedData();
  if (currentPage > Math.ceil(totalCount / pageSize) && totalCount > 0) setCurrentPage(Math.ceil(totalCount / pageSize));

  const thead = [
    { header: "Apellido y Nombre", width: "40%" },
    { header: "Email", width: "35%" },
    { header: "Perfil", width: "15%" },
    { header: "", width: "5%" },
    { header: "", width: "5%" },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.currentTarget.value);
    setCurrentPage(1);
  };

  const handleNew = () => {
    navigate("/admin/usuarios/nuevo", {
      state: { action: "A" },
    });
  };

  const handleView = (id) => {
    navigate("/admin/usuarios/" + id, {
      state: { action: "C" },
    });
  };

  const handleEdit = (id) => {
    navigate("/admin/usuarios/" + id, {
      state: { action: "E" },
    });
  };

  const handleDelete = async (id) => {
    toastConfirm("¿ Eliminar usuario ?", "El usuario dejará de tener acceso al sistema", () => doDelete(id));
  };

  const doDelete = async (id) => {
    const originalRecords = allRecords;
    const records = allRecords.filter((m) => m._id !== id);
    setAllRecords(records);
    try {
      await deleteUser(id);
    } catch (ex) {
      if (ex.response && ex.response.status === 404) toastBigError("Ese registro ya fue eliminado");
      setAllRecords(originalRecords);
    }
  };

  const nombreCompleto = (item) => {
    const apellido = item.apellido || "";
    const nombre = item.nombre || "";
    if (apellido && nombre) return apellido + ", " + nombre;
    return apellido || nombre;
  };

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <Row className="align-items-center">
                  <Col md="6">
                    <Input placeholder="Buscar..." value={searchQuery} onChange={handleSearch} />
                  </Col>
                  <Col md="6">
                    <Button className="pull-right btn-arhock" onClick={() => handleNew()}>
                      Nuevo Usuario
                    </Button>
                  </Col>
                </Row>
                <Table responsive hover>
                  <thead className="text-black">
                    <tr>
                      {thead.map((prop, key) => {
                        if (key === thead.length - 2)
                          return (
                            <th key={key} className="text-left" style={prop.width ? { width: `${prop.width}` } : ""}>
                              {prop.header}
                            </th>
                          );
                        return (
                          <th key={key} color="black" style={prop.width ? { width: `${prop.width}` } : ""}>
                            {prop.header}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {records.map((item) => (
                      <tr key={Math.random()}>
                        <td className="clickable" onClick={() => handleView(item._id)}>
                          <span className="black">{nombreCompleto(item)}</span>
                        </td>
                        <td className="clickable" onClick={() => handleView(item._id)}>
                          <span className="black">{item.email}</span>
                        </td>
                        <td className="clickable" onClick={() => handleView(item._id)}>
                          <span className="black">{item.profile ? item.profile.descripcion : ""}</span>
                        </td>
                        <td>
                          <span className="clickable" onClick={() => handleEdit(item._id)}>
                            <div className="icon icon-success">
                              <i className="fa fa-pencil-square-o" color="success" />
                            </div>
                          </span>
                        </td>
                        <td>
                          <span className="clickable" onClick={() => handleDelete(item._id)}>
                            <div className="icon icon-danger">
                              <i className="fas fa-trash-alt" color="danger" />
                            </div>
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <Row className="pull-right">
                  <PaginationControls onPageChange={(page) => handlePageChange(page)} itemsCount={totalCount} pageSize={pageSize} currentPage={currentPage} />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Usuarios;
